// extracted by mini-css-extract-plugin
module.exports = {"activityStatsContentContainer":"activityDetailsCard_activityStatsContentContainer__3UaKq"};